import request from '@/utils/request'

// 查询品牌报单信息列表分页
export function fetchList(query) {
    return request({
        url: '/taxation/brand/page',
        method: 'get',
        params: query,
    })
}

// 查询品牌报单详细
export function getObj(id) {
    return request({
        url: '/taxation/brand/detail?brandId=' + id,
        method: 'get',
    })
}
// 新增品牌报单
export function addObj(data) {
    return request({
        url: '/taxation/brand/add',
        method: 'post',
        data: data,
    })
}
// 新增品牌报单
export function statusObj(data) {
    return request({
        url: '/taxation/brand/add',
        method: 'post',
        data: data,
    })
}
// 修改品牌报单
export function putObj(data) {
    return request({
        url: '/taxation/brand/edit',
        method: 'post',
        data: data,
    })
}
// 删除品牌报单
export function delObj(data) {
    return request({
        url: '/taxation/brand/delete',
        method: 'post',
        data: data,
    })
}